import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const NavigationBarEventIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{ width: '20px', height: '20px', ...sx }}
    {...props}
  >
    <path
      fill="url(#a)"
      d="M19 4h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Zm1 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7h16v7Zm0-9H4V7a1 1 0 0 1 1-1h2v1a1 1 0 0 0 2 0V6h6v1a1 1 0 0 0 2 0V6h2a1 1 0 0 1 1 1v3Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1="2.032"
        x2="16.986"
        y1="2.251"
        y2="25.495"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B09B" />
        <stop offset="1" stopColor="#96C93D" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

NavigationBarEventIcon.defaultProps = {
  sx: null,
}
